import type { WorldPreset, WorldGenre } from '@creanizer/types'

export interface WorldPresetData {
  id: WorldPreset
  name: string
  description: string
  parameters: {
    magicLevel: number
    scienceLevel: number
    civilizationLevel: number
    dangerLevel: number
    mysteryLevel: number
    complexityLevel: number
    uniquenessLevel: number
    chaosLevel: number
  }
  defaultGenres?: WorldGenre[]
  defaultScale?: string
  defaultElements?: any
}

export const WORLD_PRESETS: WorldPresetData[] = [
  {
    id: 'modern-japan',
    name: '現代日本',
    description: '現実の日本を基にした世界観',
    parameters: {
      magicLevel: 1,
      scienceLevel: 8,
      civilizationLevel: 9,
      dangerLevel: 2,
      mysteryLevel: 2,
      complexityLevel: 7,
      uniquenessLevel: 2,
      chaosLevel: 1,
    },
    defaultScale: 'country',
  },
  {
    id: 'modern-world',
    name: '現代世界',
    description: '現実の地球を基にした一般的な世界',
    parameters: {
      magicLevel: 1,
      scienceLevel: 7,
      civilizationLevel: 7,
      dangerLevel: 3,
      mysteryLevel: 2,
      complexityLevel: 6,
      uniquenessLevel: 1,
      chaosLevel: 2,
    },
    defaultScale: 'planet',
  },
  {
    id: 'standard-fantasy',
    name: '標準ファンタジー',
    description: '剣と魔法の王道ファンタジー世界',
    parameters: {
      magicLevel: 8,
      scienceLevel: 2,
      civilizationLevel: 4,
      dangerLevel: 6,
      mysteryLevel: 7,
      complexityLevel: 5,
      uniquenessLevel: 3,
      chaosLevel: 2,
    },
    defaultGenres: ['fantasy'],
    defaultScale: 'continent',
  },
  {
    id: 'dark-fantasy',
    name: 'ダークファンタジー',
    description: '暗く危険な雰囲気のファンタジー世界',
    parameters: {
      magicLevel: 7,
      scienceLevel: 2,
      civilizationLevel: 3,
      dangerLevel: 9,
      mysteryLevel: 8,
      complexityLevel: 6,
      uniquenessLevel: 4,
      chaosLevel: 6,
    },
    defaultGenres: ['dark-fantasy'],
    defaultScale: 'continent',
  },
  {
    id: 'standard-scifi',
    name: '標準SF',
    description: '宇宙開拓時代の標準的なSF世界',
    parameters: {
      magicLevel: 1,
      scienceLevel: 10,
      civilizationLevel: 8,
      dangerLevel: 5,
      mysteryLevel: 4,
      complexityLevel: 7,
      uniquenessLevel: 4,
      chaosLevel: 3,
    },
    defaultGenres: ['sci-fi', 'space-opera'],
    defaultScale: 'galaxy',
  },
  {
    id: 'cyberpunk-city',
    name: 'サイバーパンク都市',
    description: 'ネオンきらめく近未来都市',
    parameters: {
      magicLevel: 1,
      scienceLevel: 9,
      civilizationLevel: 6,
      dangerLevel: 7,
      mysteryLevel: 4,
      complexityLevel: 8,
      uniquenessLevel: 5,
      chaosLevel: 6,
    },
    defaultGenres: ['cyberpunk'],
    defaultScale: 'city',
  },
  {
    id: 'post-apocalypse',
    name: 'ポストアポカリプス',
    description: '文明崩壊後の世界',
    parameters: {
      magicLevel: 2,
      scienceLevel: 3,
      civilizationLevel: 2,
      dangerLevel: 9,
      mysteryLevel: 6,
      complexityLevel: 5,
      uniquenessLevel: 4,
      chaosLevel: 8,
    },
    defaultGenres: ['post-apocalyptic'],
    defaultScale: 'region',
  },
  {
    id: 'medieval-europe',
    name: '中世ヨーロッパ風',
    description: '騎士と城、封建制度の世界',
    parameters: {
      magicLevel: 2,
      scienceLevel: 2,
      civilizationLevel: 4,
      dangerLevel: 5,
      mysteryLevel: 4,
      complexityLevel: 5,
      uniquenessLevel: 2,
      chaosLevel: 3,
    },
    defaultGenres: ['historical'],
    defaultScale: 'continent',
  },
  {
    id: 'ancient-civilization',
    name: '古代文明',
    description: '神話と伝説が生きている世界',
    parameters: {
      magicLevel: 5,
      scienceLevel: 1,
      civilizationLevel: 3,
      dangerLevel: 6,
      mysteryLevel: 8,
      complexityLevel: 4,
      uniquenessLevel: 3,
      chaosLevel: 4,
    },
    defaultGenres: ['mythology'],
    defaultScale: 'region',
  },
  {
    id: 'school-setting',
    name: '学園もの',
    description: '学校を舞台にした日常系世界',
    parameters: {
      magicLevel: 1,
      scienceLevel: 5,
      civilizationLevel: 6,
      dangerLevel: 1,
      mysteryLevel: 2,
      complexityLevel: 3,
      uniquenessLevel: 2,
      chaosLevel: 1,
    },
    defaultGenres: ['slice-of-life'],
    defaultScale: 'building',
  },
  {
    id: 'urban-fantasy-modern',
    name: '現代アーバンファンタジー',
    description: '現代都市に隠れた魔法世界',
    parameters: {
      magicLevel: 6,
      scienceLevel: 7,
      civilizationLevel: 7,
      dangerLevel: 4,
      mysteryLevel: 6,
      complexityLevel: 6,
      uniquenessLevel: 4,
      chaosLevel: 3,
    },
    defaultGenres: ['urban-fantasy'],
    defaultScale: 'city',
  },
  {
    id: 'space-colony',
    name: '宇宙コロニー',
    description: '宇宙植民地での生活',
    parameters: {
      magicLevel: 1,
      scienceLevel: 9,
      civilizationLevel: 7,
      dangerLevel: 6,
      mysteryLevel: 3,
      complexityLevel: 7,
      uniquenessLevel: 4,
      chaosLevel: 2,
    },
    defaultGenres: ['sci-fi'],
    defaultScale: 'solar_system',
  },
]